import { render, staticRenderFns } from "./DialogUpdateSetting.vue?vue&type=template&id=6dc32c91"
import script from "./DialogUpdateSetting.vue?vue&type=script&lang=js"
export * from "./DialogUpdateSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports